var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListItem',[_c('div',{staticClass:"flex -mx-3 p-4"},[_c('div',{staticClass:"flex-1 px-3 capitalize"},[_c('span',[_vm._v(_vm._s(_vm.entity.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }